import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IResponse } from '../../models/iresponse';
import { WholesaleCustomer } from '../../models/wholesale-customer';

@Injectable({
  providedIn: 'root'
})
export class WholesaleCustomersService {

  API_URLWholesaleCustomer = `${environment.apiUrl}/WholesaleCustomer`;

  constructor(private http: HttpClient) {
  }

  getAll(body: any): Observable<IResponse<WholesaleCustomer>> {
    const url = this.API_URLWholesaleCustomer;
    return this.http.post<IResponse<WholesaleCustomer>>(`${url}/GetCustomers`, body);
  }

  addUpdate(body: any): Observable<any> {
    const url = this.API_URLWholesaleCustomer;
    return this.http.post<any>(`${url}/AddUpdateCustomer`, body);
  }
  // DeleteProductServiceProvider(id: string): Observable<any> {
  //   const url = this.API_URLDeleteProductServiceProvider;
  //   let param = { Id: id };
  //   return this.http.delete<any>(url, { params: param });
  // }
}
